import React, { useEffect, useState } from 'react';
import { jarallax, jarallaxElement } from "jarallax";
import axiosInstance from '../axiosConfig'; 
import 'jarallax/dist/jarallax.css';
import 'jarallax/dist/jarallax.min.js';
import 'jarallax/dist/jarallax-element.min.js';

const ServicesName = () => {
    const [servicesData, setServicesData] = useState([]);
    const [heading, setHeading] = useState("");
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    jarallaxElement();

    useEffect(() => {
        // Fetch services data
        axiosInstance.get("/slider/service")
            .then((response) => {
                if (response.data.success) {
                    const { heading, link_slider_content } = response.data.slider;
                    setHeading(heading);
                    setServicesData(link_slider_content);
                } else {
                    setError("Failed to load services data.");
                }
            })
            .catch((err) => {
                setError("An error occurred while fetching the services data.");
                console.error(err);
            })
            .finally(() => setLoading(false));
    }, []);

    useEffect(() => {
        if (servicesData.length > 0) {
            jarallax(document.querySelectorAll('.jarallax'));
        }
    }, [servicesData]);

    if (loading) {
        return <div className="loading">Loading...</div>;
    }

    if (error) {
        return <div className="error">{error}</div>;
    }

    return (
        <section className="no-top">
            <div className="container">
                {/* <h2 className="text-center">{heading}</h2> */}
                <div className="row">
                    {servicesData.map((item) => (
                        <div className="col-lg-3 text-center jarallax" key={item.id} data-jarallax-element="-30">
                            <div className="de-box-a">
                                <div className="d-image">
                                    <img src={item.image} alt={item.title} />
                                </div>
                                <div className="d-deco-1"></div>
                                <div className="d-deco-2"></div>
                            </div>
                            <div className="spacer-20"></div>
                            <h4>{item.title}</h4>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
}

export default ServicesName;
